const apiUrl = (env) => {
  if (env === 'dev') {
    return "https://" + process.env.REACT_APP_BACKEND_URL + "/jsapi/v1"
  } else {
    return "https://" + process.env.REACT_APP_BACKEND_URL + "/jsapi/v1"
  }
}
export const API_URL = apiUrl(process.env.REACT_APP_ENV);
